import type { Language } from '../../i18n'
import deFlag from 'flag-icons/flags/4x3/de.svg'
import gbFlag from 'flag-icons/flags/4x3/gb.svg'
import frFlag from 'flag-icons/flags/4x3/fr.svg'
import trFlag from 'flag-icons/flags/4x3/tr.svg'

// Import only the four flags used by the app. Importing flag-icons' complete CSS
// makes Vite resolve more than 500 SVG files during local development.
const FLAG_MAP: Record<Language, string> = {
  tr: trFlag,
  en: gbFlag,
  de: deFlag,
  fr: frFlag,
}

interface Props {
  code: Language
  size?: number
  className?: string
}

export function FlagIcon({ code, size = 16, className }: Props) {
  const flagUrl = FLAG_MAP[code]
  return (
    <img
      src={flagUrl}
      alt=""
      className={className}
      width={Math.round((size * 4) / 3)}
      height={size}
      style={{
        display: 'block',
        flexShrink: 0,
        height: size,
        objectFit: 'cover',
        width: Math.round((size * 4) / 3),
      }}
      aria-hidden="true"
    />
  )
}
